<template>
  <div class="col-12">
    <AppFormCabecalho titulo="Armazenamentos" icon="mdi mdi-harddisk">
      <div slot="actions">
        <b-button
          @click="getArmazenamentos()"
          variant="outline-secondary"
          size="sm"
          class="mr-2"
        >
          <i class="mdi mdi-refresh"></i> Atualizar
        </b-button>
        <b-button @click="abrirModal()" variant="outline-secondary" size="sm">
          <i class="mdi mdi-plus-circle"></i> Adicionar Armazenamento
        </b-button>
      </div>
    </AppFormCabecalho>
    <div class="table-responsive">
      <table class="table table-sm table-striped table-bordered">
        <thead>
          <tr>
            <th>Dir. Base</th>
            <!--            <th>Tempo Reten&ccedil;&atilde;o</th>-->
            <th class="text-center">Ativo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="semArmazenamentos">
            <td colspan="3">Nenhum dispositivo cadastrado</td>
          </tr>
          <tr v-if="erroAoCarregarArmazenamentos">
            <td colspan="3" class="text-danger">
              <i class="mdi mdi-alert-outline"></i> Ocorreu um erro ao carregar
              Armazenamentos! Verifique a URL e Chave de Acesso.
            </td>
          </tr>
          <tr
            v-for="(armazenamento, index) in armazenamentos"
            :key="index"
            :class="{ 'table-success': armazenamento.ativo }"
          >
            <td>{{ armazenamento.dirBase }}</td>
            <!--            <td>{{ armazenamento.tempoRetencao }}</td>-->
            <td class="text-center">
              {{ armazenamento.ativo | ativoText }}
            </td>
            <td class="text-center">
              <b-button
                @click="editar(armazenamento)"
                size="sm"
                variant="link"
                title="Editar"
              >
                <i class="mdi mdi-pencil"></i>
              </b-button>
              <b-button
                @click="ativar(armazenamento)"
                size="sm"
                variant="link"
                title="Ativar"
              >
                <i class="mdi mdi-harddisk-plus"></i>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ArmazenamentoModal
      v-model="modal"
      :armazenamento="armazenamento"
      v-on:salvar="salvar"
    />
  </div>
</template>
<script>
import AppFormCabecalho from "../layout/AppFormCabecalho.vue";
import ArmazenamentoModal from "./ArmazenamentoModal.vue";
import ServidorApi from "@/api/servidorApi";

function armazenamentoFactory() {
  return {
    ativo: true,
    diretorioBase: "",
    tempoRetencao: ""
  };
}

const armazenamentoData = armazenamentoFactory();

export default {
  components: { AppFormCabecalho, ArmazenamentoModal },
  data() {
    return {
      carregando: false,
      erroCarregar: false,
      modal: false,
      armazenamento: armazenamentoData,
      armazenamentos: []
    };
  },
  computed: {
    semArmazenamentos() {
      return !this.erroCarregar && this.armazenamentos.length <= 0;
    },
    erroAoCarregarArmazenamentos() {
      return this.erroCarregar && this.armazenamentos.length <= 0;
    }
  },
  methods: {
    abrirModal(armazenamento = armazenamentoFactory()) {
      this.modal = true;
      this.armazenamento = armazenamento;
    },
    salvar(armazenamento) {
      if(armazenamento.id === undefined) {
        this.armazenamentos = this.armazenamentos.map(arm => {
          return { ...arm, ativo: false };
        });
      }
      if (armazenamento.idx >= 0) {
        this.armazenamentos.splice(armazenamento.idx, 1, armazenamento);
      } else {
        this.armazenamentos.push(armazenamento);
      }
      this.armazenamentos = this.armazenamentos.sort(arm => arm.dirbase)
    },
    editar(armazenamento) {
      this.armazenamento = Object.assign({}, armazenamento);
      const idx = this.armazenamentos.indexOf(armazenamento);
      Object.assign(this.armazenamento, { idx });
      this.abrirModal(this.armazenamento);
    },
    ativar(armazenamento) {
      let params = { id: armazenamento.id, ativo: true };
      ServidorApi.ativarArmazenamento(params)
        .then(() => {
          this.getArmazenamentos();
        })
        .catch(e => {
          console.log(e);
        });
    },
    getArmazenamentos() {
      this.carregando = true;
      ServidorApi.armazenamentos()
        .then(resp => {
          this.armazenamentos = resp.sort(arm => arm.dirbase);
          this.carregando = false;
          this.erroCarregar = false;
        })
        .catch(e => {
          console.log(e);
          this.carregando = false;
          this.erroCarregar = true;
        });
    }
  },
  created() {
    this.getArmazenamentos();
  },
  filters: {
    ativoText: function(value) {
      return value ? "Sim" : "Não";
    }
  }
};
</script>
